import styles from "../usersManagement/user_management_styles.module.scss";

const ROWS = 10;
const COLUMNS = 6;

const OrganizationTableShimmer = () => {
  return (
    <tbody className={styles.table_body}>
      {Array.from({ length: ROWS }).map((_, rowIdx) => (
        <tr key={`${styles[`row-${rowIdx}`]}`}>
          {Array.from({ length: COLUMNS }).map((_, colIdx) => (
            <td key={`${styles[`cell-${rowIdx}-${colIdx}`]}`}>
              <div
                className={`${styles["shimmer"]} ${styles["shimmer-cell"]}`}
              />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
};

export default OrganizationTableShimmer;
